// extracted by mini-css-extract-plugin
export default {"Checkbox":"item-suggestions-list-module__Checkbox--dAl8Y"};